/**
 * TDS · Bloque "Dedicatoria" dentro de pz-producto.
 *
 * Muestra el campo solo cuando la variante elegida lleva dedicatoria. La
 * lista de variantes que la llevan viene calculada desde Liquid en
 * data-variantes; aqui solo se compara con el input[name="id"] del form.
 *
 * Al ocultar se DESHABILITA y se VACIA el campo: un input disabled no viaja
 * con el formulario, asi que una variante sin dedicatoria nunca manda al
 * pedido un texto escrito antes de cambiar de opinion.
 *
 * Sin console.log. Arranque resistente (load + MutationObserver + eventos
 * del editor), igual que el resto de bloques tds.
 */
(function () {
  'use strict';

  var TDS_L = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || "").slice(0, 2);

  function iniciar(raiz) {
    if (!raiz || raiz.__tdsDedi) return;
    raiz.__tdsDedi = true;

    var input = raiz.querySelector('#dedicatoria-input');
    var contador = raiz.querySelector('[data-tds-dedi-contador]');
    if (!input) return;

    var ids = (raiz.getAttribute('data-variantes') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var siempre = raiz.getAttribute('data-siempre') === '1';
    var form = raiz.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var max = parseInt(input.getAttribute('maxlength'), 10) || 50;

    function varianteActual() {
      var h = form && form.querySelector('input[name="id"], select[name="id"]');
      return h ? String(h.value || '') : '';
    }

    function activa() {
      if (siempre) return true;
      // Sin lista (producto sin ninguna variante con dedicatoria): el
      // bloque no tiene sentido y se queda oculto.
      if (!ids.length) return false;
      return ids.indexOf(varianteActual()) !== -1;
    }

    function pintarContador() {
      if (!contador) return;
      var n = input.value.length;
      contador.textContent = n + '/' + max;
      contador.classList.toggle('is-lleno', n >= max);
    }

    var estadoPrevio = null;
    function aplicar() {
      var on = activa();
      if (on === estadoPrevio) return;
      estadoPrevio = on;
      raiz.hidden = !on;
      input.disabled = !on;
      input.required = on;
      if (!on) {
        input.value = '';
        pintarContador();
        silenciar();
        // Que el popup del personalizador se entere de que ya no hay
        // dedicatoria (escucha 'input' en este campo).
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    var alerta = raiz.querySelector('[data-tds-dedi-alerta]');
    function avisar(texto) {
      if (alerta) { alerta.textContent = texto; alerta.hidden = false; }
      input.classList.add('is-error');
      try { raiz.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      try { input.focus({ preventScroll: true }); } catch (e) { try { input.focus(); } catch (e2) {} }
    }
    function silenciar() {
      if (alerta) alerta.hidden = true;
      input.classList.remove('is-error');
    }

    input.addEventListener('input', function () {
      // El popup escribe aqui por programa saltandose maxlength: se recorta
      // para que el limite valga tambien en ese camino.
      if (input.value.length > max) input.value = input.value.slice(0, max);
      pintarContador();
      if (input.value.trim()) silenciar();
    });

    // Bloqueo propio: variante con dedicatoria elegida y campo vacio ->
    // no se anade al carrito y se avisa junto al campo. Va aqui ademas del
    // guardia del widget para que valga aunque el personalizador no este
    // en la pagina (o cargue tarde). Captura: corre antes que el tema.
    var ATC = 'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [data-add-to-cart], .product-form__submit';
    function falta() { return activa() && !input.value.trim(); }
    function bloquear(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      avisar(TDS_L === "de" ? "Schreibe deine persönliche Widmung, bevor du das Produkt in den Warenkorb legst." : TDS_L === "en" ? "Write your personal message before adding to cart." : TDS_L === "it" ? "Scrivi la tua dedica prima di aggiungere al carrello." : 'Escribe tu dedicatoria antes de añadir al carrito.');
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest(ATC) && falta()) bloquear(e);
    }, true);
    if (form) form.addEventListener('submit', function (e) { if (falta()) bloquear(e); }, true);

    // Cambios de variante: mismos eventos que usa el resto del tema, mas
    // el observer sobre el hidden [name=id] para temas que lo cambian sin
    // disparar nada.
    ['change', 'variant:change', 'variant-change', 'product:variant-change',
     'shopify:section:load', 'shopify:section:select'].forEach(function (ev) {
      document.addEventListener(ev, aplicar, true);
    });
    var hidden = form && form.querySelector('input[name="id"]');
    if (hidden && 'MutationObserver' in window) {
      new MutationObserver(aplicar).observe(hidden, { attributes: true, attributeFilter: ['value'] });
    }
    // Algunos selectores de variante tardan en fijar el id tras cargar.
    var intentos = 0;
    var iv = setInterval(function () {
      aplicar();
      if (++intentos >= 15) clearInterval(iv);
    }, 200);

    aplicar();
    pintarContador();
  }

  function arrancar(ambito) {
    var nodos = (ambito || document).querySelectorAll('[data-tds-dedi]');
    Array.prototype.forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
  } else {
    arrancar(document);
  }
  window.addEventListener('load', function () { arrancar(document); });

  if ('MutationObserver' in window) {
    var vigilante = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodos = muts[i].addedNodes;
        for (var j = 0; j < nodos.length; j++) {
          var n = nodos[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-tds-dedi]')) iniciar(n);
          else if (n.querySelectorAll) arrancar(n);
        }
      }
    });
    var vigilar = function () {
      if (document.body) vigilante.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) vigilar();
    else document.addEventListener('DOMContentLoaded', vigilar);
  }

  document.addEventListener('shopify:section:load', function (ev) { arrancar(ev.target); });
})();
